import type { Clip } from '@/features/clips/domain/models/clip.ts'
import useMediaStore from '../media.store.tsx'
import useTracksStore from '../tracks.store.tsx'
import { useHistoryStore } from '../history.store.tsx'
import { selectClip } from '@/features/clips/domain/use-cases/select-clip.ts'

export const cutClip = (clip: Clip): void => {
  const audioBuffer = useMediaStore.getState().media[clip.mediaId]
  if (!audioBuffer || clip.startAt === undefined) return

  const {
    addClip,
    deleteClip,
    playbackTime: cutTime,
  } = useTracksStore.getState()

  const endOfClip = clip.startAt + audioBuffer.duration

  const clipStartingAt = clip.startAt + clip.startOffset
  const clipEndingAt = endOfClip + clip.endOffset

  const isCutOnFadeIn = cutTime - clipStartingAt < clip.fadeIn
  const isCutOnFadeOut = clipEndingAt - cutTime < clip.fadeOut

  // left clip
  addClip(clip.trackId, {
    ...clip,
    id: crypto.randomUUID(),
    endOffset: cutTime - endOfClip,
    // if the fadeIn is cut, we remove it, otherwise the left clip inherits it
    fadeIn: isCutOnFadeIn ? 0 : clip.fadeIn,
    // the left clip will never have fadeOut
    fadeOut: 0,
  })

  // right clip
  addClip(clip.trackId, {
    ...clip,
    id: crypto.randomUUID(),
    startOffset: cutTime - clip.startAt,
    // the right clip will never have fadeIn
    fadeIn: 0,
    // if the fadeOut is cut, we remove it, otherwise the right clip inherits it
    fadeOut: isCutOnFadeOut ? 0 : clip.fadeOut,
  })

  deleteClip(clip.trackId, clip.id)
  selectClip(undefined)
  useHistoryStore.getState().saveSnapshot()
}
